import { LexplusProfileDto } from '@lexplus-authentication-api';

export class ProfileStateSetProfile {
  public static readonly type = '[UserState] Set profile';

  constructor(public profile: LexplusProfileDto) {}
}

/**
 * Replaces the profile's `istKundeDokumentenManagerAktiv` with the switch of the effective Kunde —
 * the impersonated one while a Neosys admin impersonates — so `ProfileState.hasPermission` decides
 * on the Kunde the user actually works in.
 */
export class ProfileStateSetKundeDokumentenManagerAktiv {
  public static readonly type = '[Profile] Set Kunde Dokumenten-Manager Aktiv';

  constructor(public istKundeDokumentenManagerAktiv: boolean) {}
}

export class ProfileStateSetIsLoggedIn {
  public static readonly type = '[Profile] Set Is Logged In';

  constructor(public isLoggedIn: boolean) {}
}

export class ProfileStateSetAppDeviceId {
  public static readonly type = '[Profile] Set App Device Id';

  constructor(public appDeviceId: string) {}
}

export class ProfileStateSetBrowserLanguage {
  public static readonly type = '[Profile] Set Browser Language';

  constructor(public browserLanguage: string) {}
}

export class ProfileStateUpdateLanguage {
  public static readonly type = '[Profile] Update Language';

  constructor(
    public language: string,
    public isLoggedIn: boolean,
  ) {}
}

export class ProfileStateUpdatePasswordExpiration {
  public static readonly type = '[Profile] Update Password Expiration';

  constructor(
    public showBanner: boolean,
    public passwordExpirationDate?: string,
  ) {}
}

/**
 * Resets the profile state to its defaults (logout), but keeps the `appDeviceId` so
 * that the "stay signed in" device trust (2FA skip) is preserved.
 */
export class ProfileStateClear {
  public static readonly type = '[Profile] Clear';
}
